import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import AdminSidebar from "../../layouts/AdminSidebar";
import { Trash, Plus } from "react-bootstrap-icons";
import { handleNumericInput } from "../../util/utils";
import { authCall } from "../../../services";
import ImageUploads from "../../util/ImageUploads";

function DailyDealsPage() {
  const today = moment().format("YYYY-MM-DD");
  const [loading, setLoading] = useState(false);
  const { current } = useSelector((state) => state.user);
  const [loadingSubs, setLoadingSubs] = useState("");
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [companies, setCompanaies] = useState([]);

  const initialField = {
    id: 1,
    date: today,
    company: "All Companies",
    activity: "",
    activityList: [],
    priceOne: "",
    priceOneQuantity: "",
    priceTwo: "",
    priceTwoQuantity: "",
    priceThree: "",
    priceThreeQuantity: "",
    voucherImage: "",
    isItemPhotoUploaded: false,
    new: true,
  };

  const [dailyDeals, setDailyDeals] = useState([]);

  const getDealDetails = async () => {
    setLoading(true);
    const resp = await authCall("getDailyDeals", {});
    const deals = [];
    if (resp?.type === "success") {
      resp?.payload.forEach(async (el, index) => {
        deals.push({
          id: index,
          dailyDealId: el.id,
          date: el.deal_date,
          company: el.company,
          activityId: el.activity_id,
          activity: el.activity,
          activityList: [],
          priceOne: el.prize_one,
          priceOneQuantity: el.prize_one_quantity,
          priceTwo: el.prize_two,
          priceTwoQuantity: el.prize_two_quantity,
          priceThree: el.prize_three,
          priceThreeQuantity: el.prize_three_quantity,
          priceOneRemainQuantity: el.prize_one_quantity_remain,
          priceTwoRemainQuantity: el.prize_two_quantity_remain,
          priceThreeRemainQuantity: el.prize_one_quantity_remain,
          voucherImage: el.voucher,
        });
      });
      setDailyDeals(deals);
      setLoading(false);
    }
  };

  const getCompanies = async () => {
    const resp = await authCall("getSearchList", {
      type: "booking",
    });
    if (resp?.type === "success") {
      setCompanaies(resp?.payload?.details);
    }
  };

  const getCompanyActivities = async (companyName) => {
    const resp = await authCall("getCompanyActivities", {
      companyName: companyName,
    });

    if (resp?.type === "success") {
      return resp?.payload?.details?.map((e) => ({
        ...e,
        label: e.activity_name,
      }));
    } else {
      return [];
    }
  };

  useEffect(() => {
    getDealDetails();
    getCompanies();
  }, []);

  const addDeal = () => {
    const newFields = [];
    newFields.push({ ...initialField, id: dailyDeals.length + 1 });
    setDailyDeals([...dailyDeals, ...newFields]);
  };

  const handleChangePlan = (id, name, value) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id ? { ...field, [name]: value } : field
      )
    );
  };

  const handleChangeQuantity = (id, name, value) => {
    const inputValue = handleNumericInput(value);
    if (inputValue !== null && inputValue.length < 5) {
      setDailyDeals(
        dailyDeals.map((field) =>
          field.id === id ? { ...field, [name]: inputValue } : field
        )
      );
    }
  };

  const handleSubmit = async (item) => {
    toast.dismiss();
    setLoadingSubs(`loading${item.id}`);
    const values = {
      userId: current.id,
      dailyDealId: item?.dailyDealId || "",
      date: item.date,
      company: item.company,
      activityId: item.activityId,
      activity: item.activity,
      priceOne: item.priceOne,
      priceOneQuantity: item.priceOneQuantity,
      priceTwo: item.priceTwo,
      priceTwoQuantity: item.priceTwoQuantity,
      priceThree: item.priceThree,
      priceThreeQuantity: item.priceThreeQuantity,
      voucherImage: item.isItemPhotoUploaded ? item.voucherImage : "",
    };
    const resp = await authCall("dailyDeals", values);
    if (resp?.type === "success") {
      setLoadingSubs("");
      toast.success(resp?.message);
    } else {
      setLoadingSubs("");
      toast.error(resp?.message);
    }
  };

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
          disabled={loadingDelete || false}
        >
          {loadingDelete ? "Loading..." : "Yes"}
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    if (el.dailyDealId) {
      const resp = await authCall("deleteDailyDeal", {
        dailyDealId: el.dailyDealId,
        isSoft: true,
      });
      setLoadingDelete(true);
      if (resp?.type === "success") {
        closeToast();
        toast.success(resp?.message);
        setLoadingDelete(false);
        getDealDetails();
      } else {
        toast.error(resp?.message);
        setLoadingDelete(false);
      }
    } else {
      setDailyDeals(dailyDeals.filter((e) => e.id !== el.id));
      closeToast();
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const handleChangeComapny = async (id, selected) => {
    const activitiesList = await getCompanyActivities(selected);
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, company: selected, activitiesList: activitiesList }
          : field
      )
    );
  };

  const handleChangeActivity = (id, selected) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, activityId: selected.id, activity: selected }
          : field
      )
    );
  };

  const getItemPhoto = (id) => (img) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, voucherImage: img, isItemPhotoUploaded: true }
          : field
      )
    );
  };

  return (
    <>
      <div className="restaurant-details-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Daily Deals</div>

                {/* daily deals */}
                <div className="details-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div
                          className="main-heading2 mb-3 mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Daily Deals:
                          {loading && (
                            <Skeleton count={1} height={31} width={120} />
                          )}
                          {!loading && (
                            <Button
                              className="btn btn-custom btn-custom-sm fs-16"
                              onClick={addDeal}
                            >
                              <Plus />
                              Add Deal
                            </Button>
                          )}
                        </div>
                        {loading && (
                          <div className="text-center mt-3">
                            Loading... Please wait
                          </div>
                        )}
                        {!loading &&
                          dailyDeals.map((field, index) => (
                            <div key={index}>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-4">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Date
                                  </label>
                                  <input
                                    required
                                    type="date"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.date}
                                    name="date"
                                    onChange={(e) =>
                                      handleChangePlan(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-4">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Company
                                  </label>
                                  <Select
                                    className="text-body mt-1"
                                    placeholder="Select"
                                    value={{
                                      label: field?.company,
                                      name: field?.company,
                                    }}
                                    onChange={(e) =>
                                      handleChangeComapny(
                                        field.id,
                                        e?.company_name
                                      )
                                    }
                                    options={companies}
                                  />
                                </div>
                                <div className="col-4">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Activities
                                  </label>
                                  <Select
                                    className="text-body mt-1"
                                    placeholder="Select"
                                    value={field.activity}
                                    onChange={(e) =>
                                      handleChangeActivity(field.id, e)
                                    }
                                    options={field?.activitiesList}
                                  />
                                </div>
                              </div>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Prize One
                                  </label>
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.priceOne}
                                    name="priceOne"
                                    onChange={(e) =>
                                      handleChangePlan(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-2">
                                  <div
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary text-center"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Quantity
                                  </div>
                                  <div style={{ display: "flex", gap: 5 }}>
                                    <input
                                      required
                                      type="text"
                                      style={{ width: "50%" }}
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.priceOneQuantity}
                                      name="priceOneQuantity"
                                      onChange={(e) =>
                                        handleChangeQuantity(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                    <input
                                      disabled
                                      type="text"
                                      style={{ width: "50%" }}
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.priceOneRemainQuantity}
                                      name="priceOneRemainQuantity"
                                    />
                                  </div>
                                </div>

                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Prize Two
                                  </label>
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.priceTwo}
                                    name="priceTwo"
                                    onChange={(e) =>
                                      handleChangePlan(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-2">
                                  <div
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary text-center"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Quantity
                                  </div>
                                  <div style={{ display: "flex", gap: 5 }}>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.priceTwoQuantity}
                                      name="priceTwoQuantity"
                                      onChange={(e) =>
                                        handleChangeQuantity(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                    <input
                                      disabled
                                      type="text"
                                      style={{ width: "50%" }}
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.priceTwoRemainQuantity}
                                      name="priceTwoRemainQuantity"
                                    />
                                  </div>
                                </div>

                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Prize Three
                                  </label>
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.priceThree}
                                    name="priceThree"
                                    onChange={(e) =>
                                      handleChangePlan(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-2">
                                  <div
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary text-center"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Quantity
                                  </div>
                                  <div style={{ display: "flex", gap: 5 }}>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.priceThreeQuantity}
                                      name="priceThreeQuantity"
                                      onChange={(e) =>
                                        handleChangeQuantity(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                    <input
                                      disabled
                                      type="text"
                                      style={{ width: "50%" }}
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.priceThreeRemainQuantity}
                                      name="priceThreeRemainQuantity"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-4">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Upload Voucher Image
                                  </label>
                                  <ImageUploads
                                    getImage={getItemPhoto(field.id)}
                                    uploadedImage={field?.voucherImage}
                                    aspectRation={3 / 2}
                                  />
                                </div>
                                <div className="col-4">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Action
                                  </label>
                                  <div className="d-flex align-items-center">
                                    <button
                                      type="button"
                                      style={{
                                        height: 40,
                                        width: "50%",
                                        zIndex: 0,
                                      }}
                                      className="btn btn-custom btn-custom-sm fs-16"
                                      onClick={() => handleSubmit(field)}
                                      disabled={
                                        `loading${field?.id}` === loadingSubs ||
                                        false
                                      }
                                    >
                                      {`loading${field?.id}` === loadingSubs
                                        ? "Loading..."
                                        : field.new
                                        ? `Submit`
                                        : "Update"}
                                    </button>
                                    {dailyDeals.length > 1 && (
                                      <Trash
                                        onClick={() => handleDelete(field)}
                                        className="cursor-pointer"
                                        style={{
                                          marginLeft: 10,
                                          color: "red",
                                          width: 25,
                                          height: 25,
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                        {dailyDeals.length === 0 && (
                          <div className="text-center mt-3">
                            No deals available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DailyDealsPage;
